import { render, staticRenderFns } from "./kdFaultInfo.vue?vue&type=template&id=354c2880"
import script from "./kdFaultInfo.vue?vue&type=script&lang=js"
export * from "./kdFaultInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports